<router-outlet></router-outlet>

<!-- <div class="loader-save" *ngIf="isLoadingPdf">
    <p class="loading-img">
        <img class="placeholder-img" src="/assets/img/loader/ajax-loader.gif" />
    </p>
    <h4 class="msg-title">Please wait</h4>
    <p class="msg">{{ loadingMessage }}</p>
</div> -->



<!-- <div class="loading-buttons" *ngIf="isLoadingPdf">
     <div class="loading-icon">
         <div class="spinner"></div>
         <h4 class="msg-title">Please wait</h4>
         <p class="msg">{{ loadingMessage }}</p>
     </div>
</div> -->


<div class="loading-buttons" id="loader" style="display: none">
  <div class="loading-icon">
    <!-- <div class="spinner"></div>  -->
    <img class="placeholder-img" src="/assets/img/loader/spinner.gif" />
  </div>
  <!-- <h4 class="msg-title">Please wait...</h4>  -->
  <!-- <p class="loader-message">{{ loaderService.loaderMessage }}</p> -->
</div>
